@if (gridOptions) {
  <div
    cdkDrag
    (cdkDragStarted)="dragStart()"
    (cdkDragEnded)="dragEnd()"
    class="rfq-timeline rfq-drag"
  >
    <div
      class="rfq-timeline__menu-bar"
      cdkDragHandle
      (mousedown)="updateZIndex()"
    >
      <div>RFQ Timeline</div>
      <button
        class="rfq-timeline__menu-bar__right-button-close"
        (click)="closeWindow()"
      ></button>
    </div>
    @if (gridOptions.rowData.length) {
      <ag-grid-angular
        class="ag-theme-balham-dark rfq-timeline__grid"
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        [sideBar]="sideBarDef"
        (firstDataRendered)="firstDataRendered()"
      ></ag-grid-angular>
    }
  </div>
}
